<template>
  <div class="controls">
    <div class="controls__start">
      <button
        v-tooltip="'Return to previous page'"
        class="button"
        aria-label="Back"
        @click="() => $router.go(-1)"
      >
        <SVGIcon
          class="me-1"
          :iconName="'chevron_left'"
          :width="'18px'"
          :height="'18px'"
        />
        <span>Back</span>
      </button>
    </div>
  </div>
  <ValidatorCharts v-if="sessionIds.length > 0" :sessionIds="sessionIds" />
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';
import ValidatorCharts from '@/components/TrainerComponent/TrainerExperimentAndSessions/ValidatorCharts.vue';

export default {
  name: 'TrainingCharts',
  components: {
    ValidatorCharts,
    SVGIcon,
  },
  data() {
    return {
      sessionIds: [],
    };
  },
  computed: {
    currentTrainSession() {
      return this.$store.state.experiments.currentSession;
    },
  },
  created() {
    if (this.$route.query.session_ids) {
      // parse int or Array
      this.sessionIds = JSON.parse(decodeURI(this.$route.query.session_ids));
    }
  },
};
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  margin: 20px 20px 5px 20px;
  align-items: center;

  &__count {
    font-weight: bold;
    font-size: 1rem;
  }

  &__start {
    display: flex;
    justify-content: flex-start;
    width: fit-content;
    gap: 10px;
  }

  &__end {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }

  &__actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    height: 100%;
  }
}

.button {
    background: white;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 26px;
    padding: 0;
    box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 1);
    padding: 4px 8px;
    gap: 2px;
    width: fit-content;

    @include themify() {
      color: themed('body-text-color')
    }

    &.highlight {
      background: var(--button-color);
      color: var(--button-text-color);

      svg {
        margin-right: 5px;
      }
    }

    &:hover {
      background: rgba(var(--color-primary-100-rgb), 0.5);
    }

    &.delete:not([disabled]) {
      @include themify() {
        background: themed('button-delete');
        color: themed('button-delete-text');
      }
    }

    &.delete[disabled] {
      border: none;
    }

    &.delete:hover:not([disabled]) {
      @include themify() {
        background: $color-red-300;
        color: themed('button-delete-text');
      }
    }
  }
</style>
